import React from 'react';
import { callbackExists } from 'core/utils/global-utils';
import { KEYBOARD_EVENT_KEYS } from 'core/constants';

export function bindKeyboardControls(
	e: React.KeyboardEvent<HTMLElement>,
	callback?: (e: React.KeyboardEvent<HTMLElement>) => void,
) {
	if (
		e &&
		(e.key === KEYBOARD_EVENT_KEYS.SPACEBAR ||
			e.key === KEYBOARD_EVENT_KEYS.ENTER)
	) {
		e.preventDefault();

		// If no callback specified, trigger a click on the element
		if (callbackExists(callback)) {
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			callback!(e);
		} else {
			(e.target as HTMLButtonElement).click();
		}
	}
}

export function disableSpacebarScroll(
	e: React.KeyboardEvent<HTMLButtonElement>,
) {
	if (e && e.key === ' ') {
		e.preventDefault();
	}
}
